var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-btn',{attrs:{"color":_vm.color,"text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(" Close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }